import type { PersonaProfile } from '../types';

export const profile: PersonaProfile = {
  id: 'user_dan_roberts',
  name: 'Dan Roberts',
  email: 'dan.roberts@godmode.com',
  age: 32,
  jobRole: 'Software Engineer',
  company: 'TechCorp',
  industry: 'Technology',
  yearsExperience: 10,
  salary: 165000,
  currency: 'USD',
  bio: 'Software engineer dedicated to building physical strength, achieving financial independence, and maintaining strong relationships with family and friends.',
  timezone: 'America/Los_Angeles',
  avatarUrl: '/avatars/dan-roberts.jpg'
};